import store from '@/state/store';
import { setLogo } from '@/api/project';
import projectSlice from '@/state/project.slice';
import { handleError } from '@/actions/common';

export default async (projectId: string, file: File) => {
  try {
    store.dispatch(projectSlice.actions.logoBusy(projectId));
    const source = await setLogo(projectId, file);
    store.dispatch(projectSlice.actions.logoIdle({ projectId, source }));
  } catch (error) {
    store.dispatch(projectSlice.actions.logoError(projectId));
    handleError(error);
  }
};